import React from 'react';
import { Calendar, FileText, Mail, Phone, Globe, Building2 } from 'lucide-react';
import { PREFERRED_PARTNERS, trackPartnerContact } from '../DistributionPartners';

const pill = 'inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors';

export const ChatCtaRow = ({ onRequestDemo, onRequestQuote }) => (
  <div className="ml-10 flex flex-wrap gap-2" data-testid="charlie-cta-row">
    <button type="button" onClick={() => onRequestQuote?.({ resource: 'charlie-echo' })} className={`${pill} bg-orange-500 text-white hover:bg-orange-600`} data-testid="charlie-cta-quote">
      <FileText className="h-3.5 w-3.5" /> Request a Quote
    </button>
    <button type="button" onClick={() => onRequestDemo?.({ resource: 'charlie-echo' })} className={`${pill} border border-blue-200 bg-white text-blue-700 hover:bg-blue-50`} data-testid="charlie-cta-demo">
      <Calendar className="h-3.5 w-3.5" /> Request a Demo
    </button>
  </div>
);

const Option = ({ rank, name, sub, children, testid }) => (
  <div className="flex gap-3 py-3 first:pt-0 last:pb-0" data-testid={testid}>
    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#1e2d3b] text-[11px] font-bold text-white">{rank}</span>
    <div className="min-w-0 flex-1">
      <p className="text-sm font-bold text-[#1e2d3b]">{name} <span className="ml-1 text-[11px] font-medium text-slate-500">{sub}</span></p>
      <div className="mt-1.5 flex flex-wrap gap-1.5">{children}</div>
    </div>
  </div>
);

const link = 'inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white px-2.5 py-1 text-[11px] font-semibold text-slate-700 hover:border-blue-300 hover:text-blue-700 transition-colors';

export const ChatWhereToBuy = ({ onRequestQuote }) => (
  <div className="ml-10 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm divide-y divide-slate-100" data-testid="charlie-where-to-buy">
    {PREFERRED_PARTNERS.map((p, i) => (
      <Option key={p.id} rank={i + 1} name={p.name} sub="Preferred distribution partner" testid={`charlie-buy-${p.id}`}>
        <a href={`mailto:${p.email}`} onClick={() => trackPartnerContact(p.name, 'email')} className={link}><Mail className="h-3 w-3 text-blue-500" /> Email</a>
        {p.phone && <a href={`tel:${p.phone.replace(/[^\d+]/g, '')}`} onClick={() => trackPartnerContact(p.name, 'phone')} className={link}><Phone className="h-3 w-3 text-blue-500" /> {p.phone}</a>}
        <a href={p.website} target="_blank" rel="noopener noreferrer" onClick={() => trackPartnerContact(p.name, 'website')} className={link}><Globe className="h-3 w-3 text-blue-500" /> Website</a>
      </Option>
    ))}
    <Option rank={3} name="CTRL Systems" sub="Buy direct" testid="charlie-buy-ctrl">
      <button type="button" onClick={() => onRequestQuote?.({ resource: 'charlie-echo' })} className={`${link} !border-orange-300 !bg-orange-500 !text-white hover:!bg-orange-600`} data-testid="charlie-buy-ctrl-quote">
        <FileText className="h-3 w-3" /> Request a Quote
      </button>
      <a href="mailto:sales@ctrlsys.com" className={link}><Mail className="h-3 w-3 text-blue-500" /> sales@ctrlsys.com</a>
      <a href="tel:+14108765676" className={link}><Building2 className="h-3 w-3 text-blue-500" /> +1 (410) 876-5676</a>
    </Option>
  </div>
);
